
import { match } from "../../fable_modules/fable-library-js.5.0.0-rc.2/RegExp.js";
import { split, join, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { ofArray as ofArray_1, FSharpMap__TryFind, FSharpMap__ContainsKey } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { bind, map, filter, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { tryHead, contains as contains_1, append as append_2, map as map_3, item, choose } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Array.js";
import { tryParse, minValue } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { FSharpRef } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { toArray as toArray_1, empty as empty_1, singleton as singleton_1, append, map as map_1, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { exists, head, length, sortBy, toArray, partition, append as append_1, ofArray, choose as choose_1, cons, map as map_2, contains, singleton, filter as filter_1, empty, tryFind } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { RouterModule_encodeQueryString, RouterModule_encodeParts, RouterModule_nav, RouterModule_urlSegments } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { createObj, comparePrimitives, stringHash, equals } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Array_distinct, List_distinctBy } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { State$1, TableMsg$1 } from "./Types.js";
import { RequestedValue$1 } from "../../Shared/Shared.js";
import { Cmd_ofEffect, Cmd_none, Cmd_batch } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { RowSort, SavedColumnFilter, RowSortDirection, TableConfiguration as TableConfiguration_1, SavedTableFilter, TableConfiguration_$reflection } from "../../Shared/User.js";
import { string_type, option_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ValidationOnGetRequest } from "../../ErrorHandling.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";

const legacyCustomPropertyColumnIdPattern = /^(global|category-(LabelId )?[0-9a-fA-F-]{36}|user|employee|external-person|subcontractor|room|project|construction-site|vehicle|student|school-class|api-receiver)-(.+)$/gu;

function legacyCustomPropertySharedColumnId(columnId) {
    const legacyMatch = match(legacyCustomPropertyColumnIdPattern, columnId);
    if (legacyMatch != null) {
        return concat("custom-property-", ...(legacyMatch[3] || ""));
    }
    else {
        return undefined;
    }
}

function migrateColumnId(columnDefinitionMap, columnId) {
    if (FSharpMap__ContainsKey(columnDefinitionMap, columnId)) {
        return columnId;
    }
    else {
        return defaultArg(filter((key) => FSharpMap__ContainsKey(columnDefinitionMap, key), legacyCustomPropertySharedColumnId(columnId)), columnId);
    }
}

export function tryParseDateRangeFilterValues(filterValues) {
    const parsedValues = choose((filterValue) => {
        let matchValue;
        let outArg = minValue();
        matchValue = [tryParse(filterValue, new FSharpRef(() => outArg, (v) => {
            outArg = v;
        })), outArg];
        if (matchValue[0]) {
            return matchValue[1];
        }
        else {
            return undefined;
        }
    }, filterValues);
    if ((parsedValues.length === filterValues.length) && ((parsedValues.length === 1) ? true : (parsedValues.length === 2))) {
        return parsedValues;
    }
    else {
        return undefined;
    }
}

export function currentQueryParams() {
    return defaultArg(map((queryParams) => toList(delay(() => map_1((entry) => [item(0, entry), item(1, entry)], (new URLSearchParams(queryParams)).entries()))), tryFind((segment) => segment.startsWith("?"), RouterModule_urlSegments(window.location.hash, 1))), empty());
}

export function navigateWithQueryParams(queryParams) {
    RouterModule_nav(singleton(RouterModule_encodeParts(filter_1((segment) => !segment.startsWith("?"), RouterModule_urlSegments(window.location.hash, 1)), 1) + RouterModule_encodeQueryString(queryParams)), 2, 1);
}

export function setQueryParams(key, value) {
    const oldQueryParams = filter_1((tupledArg) => !equals(legacyCustomPropertySharedColumnId(tupledArg[0]), key), currentQueryParams());
    navigateWithQueryParams(contains(key, map_2((tuple) => tuple[0], oldQueryParams), {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    }) ? ((value === "") ? filter_1((tupledArg_1) => (tupledArg_1[0] !== key), oldQueryParams) : map_2((tupledArg_2) => {
        const queryParamId_2 = tupledArg_2[0];
        if (queryParamId_2 === key) {
            return [queryParamId_2, value];
        }
        else {
            return [queryParamId_2, tupledArg_2[1]];
        }
    }, oldQueryParams)) : cons([key, value], oldQueryParams));
}

function toQueryParamValue(columnDefinition, filterValue) {
    const matchValue = columnDefinition.Filter;
    switch (matchValue) {
        case "select":
        case "categorySelect":
        case "locationSelect":
        case "dateRange":
            return join(",", filterValue);
        default:
            return filterValue;
    }
}

function queryParamsWithoutTableFilters(columnDefinitionMap) {
    return filter_1((tupledArg) => {
        const queryParamId = tupledArg[0];
        if (queryParamId !== "global-search") {
            return !FSharpMap__ContainsKey(columnDefinitionMap, migrateColumnId(columnDefinitionMap, queryParamId));
        }
        else {
            return false;
        }
    }, currentQueryParams());
}

export function removeTableFilterQueryParams(columnDefinitionMap) {
    navigateWithQueryParams(queryParamsWithoutTableFilters(columnDefinitionMap));
}

export function writeTableFilterQueryParams(columnDefinitionMap, globalSearchPattern, columnFilters) {
    const tableFilterQueryParams = filter_1((tupledArg) => (tupledArg[1] !== ""), toList(delay(() => append((globalSearchPattern !== "") ? singleton_1(["global-search", globalSearchPattern]) : empty_1(), delay(() => choose_1((columnFilter) => map((columnDefinition) => [columnFilter.id, toQueryParamValue(columnDefinition, columnFilter.value)], FSharpMap__TryFind(columnDefinitionMap, columnFilter.id)), ofArray(columnFilters)))))));
    navigateWithQueryParams(append_1(queryParamsWithoutTableFilters(columnDefinitionMap), tableFilterQueryParams));
}

export function readInitialQueryParams(columnDefinitionsMap) {
    const matchValue = tryFind((segment) => segment.startsWith("?"), RouterModule_urlSegments(window.location.hash, 1));
    if (matchValue == null) {
        return empty();
    }
    else {
        const queryParams = matchValue;
        const patternInput = partition((tupledArg) => (tupledArg[0] === "global-search"), toList(delay(() => map_1((entry) => [item(0, entry), item(1, entry)], (new URLSearchParams(queryParams)).entries()))));
        const globalSearch = patternInput[0];
        const columnFiltersMsg = new TableMsg$1(5, [toArray(List_distinctBy((_arg_2) => _arg_2.id, map_2((tuple_1) => tuple_1[1], sortBy((tuple) => tuple[0], choose_1((tupledArg_1) => {
            const queryParamId_1 = tupledArg_1[0];
            const queryParamValue = tupledArg_1[1];
            const columnId = migrateColumnId(columnDefinitionsMap, queryParamId_1);
            return map((columnFilter) => [queryParamId_1 !== columnId, columnFilter], bind((columnDefinition) => {
                const matchValue_1 = columnDefinition.Filter;
                switch (matchValue_1) {
                    case "select":
                    case "categorySelect":
                    case "locationSelect":
                        return {
                            id: columnId,
                            value: split(queryParamValue, [","], undefined, 0),
                        };
                    case "dateRange": {
                        const filterValues = split(queryParamValue, [","], undefined, 0);
                        return map((_arg_1) => ({
                            id: columnId,
                            value: filterValues,
                        }), tryParseDateRangeFilterValues(filterValues));
                    }
                    default:
                        return {
                            id: columnId,
                            value: queryParamValue,
                        };
                }
            }, FSharpMap__TryFind(columnDefinitionsMap, columnId)));
        }, patternInput[1]), {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        })), {
            Equals: (x_1, y_1) => (x_1 === y_1),
            GetHashCode: (x_1) => (stringHash(x_1) | 0),
        }))]);
        if (length(globalSearch) === 1) {
            return ofArray([columnFiltersMsg, new TableMsg$1(1, [head(globalSearch)[1]])]);
        }
        else {
            return singleton(columnFiltersMsg);
        }
    }
}

export function init(tableKey, saveTableConfiguration, defaultColumnFilters, defaultColumnSorting, withQueryParameters, columnDefinitions) {
    const columnDefinitionMap = ofArray_1(map_3((columnDefinition) => [columnDefinition.Id, columnDefinition], columnDefinitions), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    });
    return [new State$1(tableKey, saveTableConfiguration, "", () => ({}), false, false, defaultArg(map(toArray, defaultColumnFilters), []), [{
        desc: defaultColumnSorting[1] === "desc",
        id: defaultColumnSorting[0],
    }], map_3((_arg) => _arg.Id, columnDefinitions), map_3((_arg_1) => _arg_1.Id, columnDefinitions), new RequestedValue$1(0, []), columnDefinitions, columnDefinitionMap, defaultColumnFilters, defaultColumnSorting, empty(), withQueryParameters), saveTableConfiguration ? Cmd_batch(toList(delay(() => append(singleton_1(Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), option_type(TableConfiguration_$reflection())));
        }, refreshOn)))(true).then((_arg_2) => {
            const result_1 = _arg_2;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), concat("/api/users/configuration/table/", ...tableKey), (Item) => (new TableMsg$1(16, [Item])), (Item_1) => (new TableMsg$1(19, [Item_1])))), delay(() => (withQueryParameters ? map_2((msg) => singleton((dispatch) => {
        dispatch(msg);
    }), readInitialQueryParams(columnDefinitionMap)) : empty_1())))))) : Cmd_batch(toList(delay(() => (withQueryParameters ? map_2((msg_2) => singleton((dispatch_1) => {
        dispatch_1(msg_2);
    }), readInitialQueryParams(columnDefinitionMap)) : empty_1()))))];
}

export function update(msg, state) {
    let VisibleColumns_3, array_25, ColumnOrder_2, matchValue, rowSort, id_1, tableConfiguration_2, VisibleColumns_4, body, array_7;
    switch (msg.tag) {
        case 1:
            return [new State$1(state.TableKey, state.SaveTableConfiguration, msg.fields[0], state.SelectedRows, state.CSVDownloadRunning, state.IsFullscreen, state.ColumnFilters, state.ColumnSorting, state.VisibleColumns, state.ColumnOrder, state.TableConfiguration, state.ColumnDefinitions, state.ColumnDefinitionMap, state.DefaultColumnFilters, state.DefaultColumnSorting, state.SavedFilters, state.WithQueryParameters), Cmd_none()];
        case 2:
            return [new State$1(state.TableKey, state.SaveTableConfiguration, state.GlobalSearchPattern, msg.fields[0], state.CSVDownloadRunning, state.IsFullscreen, state.ColumnFilters, state.ColumnSorting, state.VisibleColumns, state.ColumnOrder, state.TableConfiguration, state.ColumnDefinitions, state.ColumnDefinitionMap, state.DefaultColumnFilters, state.DefaultColumnSorting, state.SavedFilters, state.WithQueryParameters), Cmd_none()];
        case 3:
            return [new State$1(state.TableKey, state.SaveTableConfiguration, state.GlobalSearchPattern, state.SelectedRows, msg.fields[0], state.IsFullscreen, state.ColumnFilters, state.ColumnSorting, state.VisibleColumns, state.ColumnOrder, state.TableConfiguration, state.ColumnDefinitions, state.ColumnDefinitionMap, state.DefaultColumnFilters, state.DefaultColumnSorting, state.SavedFilters, state.WithQueryParameters), Cmd_none()];
        case 4:
            return [new State$1(state.TableKey, state.SaveTableConfiguration, state.GlobalSearchPattern, state.SelectedRows, state.CSVDownloadRunning, !state.IsFullscreen, state.ColumnFilters, state.ColumnSorting, state.VisibleColumns, state.ColumnOrder, state.TableConfiguration, state.ColumnDefinitions, state.ColumnDefinitionMap, state.DefaultColumnFilters, state.DefaultColumnSorting, state.SavedFilters, state.WithQueryParameters), Cmd_none()];
        case 5:
            return [new State$1(state.TableKey, state.SaveTableConfiguration, state.GlobalSearchPattern, state.SelectedRows, state.CSVDownloadRunning, state.IsFullscreen, msg.fields[0], state.ColumnSorting, state.VisibleColumns, state.ColumnOrder, state.TableConfiguration, state.ColumnDefinitions, state.ColumnDefinitionMap, state.DefaultColumnFilters, state.DefaultColumnSorting, state.SavedFilters, state.WithQueryParameters), Cmd_none()];
        case 6: {
            const filters_1 = msg.fields[0];
            return [new State$1(state.TableKey, state.SaveTableConfiguration, state.GlobalSearchPattern, state.SelectedRows, state.CSVDownloadRunning, state.IsFullscreen, filters_1, state.ColumnSorting, state.VisibleColumns, state.ColumnOrder, state.TableConfiguration, state.ColumnDefinitions, state.ColumnDefinitionMap, state.DefaultColumnFilters, state.DefaultColumnSorting, state.SavedFilters, state.WithQueryParameters), state.WithQueryParameters ? Cmd_ofEffect((_arg_3) => {
                writeTableFilterQueryParams(state.ColumnDefinitionMap, state.GlobalSearchPattern, filters_1);
            }) : Cmd_none()];
        }
        case 7:
            return [new State$1(state.TableKey, state.SaveTableConfiguration, state.GlobalSearchPattern, state.SelectedRows, state.CSVDownloadRunning, state.IsFullscreen, state.ColumnFilters, msg.fields[0], state.VisibleColumns, state.ColumnOrder, state.TableConfiguration, state.ColumnDefinitions, state.ColumnDefinitionMap, state.DefaultColumnFilters, state.DefaultColumnSorting, state.SavedFilters, state.WithQueryParameters), singleton((dispatch) => {
                dispatch(new TableMsg$1(17, []));
            })];
        case 8: {
            const changedColumns = map_3((tupledArg) => [tupledArg[0], tupledArg[1]], toArray_1(Object.entries(msg.fields[0])));
            const addedColumns = choose((tupledArg_1) => {
                if (tupledArg_1[1]) {
                    return tupledArg_1[0];
                }
                else {
                    return undefined;
                }
            }, changedColumns);
            const hiddenColumns = choose((tupledArg_2) => {
                if (!tupledArg_2[1]) {
                    return tupledArg_2[0];
                }
                else {
                    return undefined;
                }
            }, changedColumns);
            return [new State$1(state.TableKey, state.SaveTableConfiguration, state.GlobalSearchPattern, state.SelectedRows, state.CSVDownloadRunning, state.IsFullscreen, state.ColumnFilters, state.ColumnSorting, append_2(addedColumns, state.VisibleColumns.filter((columnId_5) => !contains_1(columnId_5, hiddenColumns, {
                Equals: (x_4, y_4) => (x_4 === y_4),
                GetHashCode: (x_4) => (stringHash(x_4) | 0),
            }))), state.ColumnOrder, state.TableConfiguration, state.ColumnDefinitions, state.ColumnDefinitionMap, state.DefaultColumnFilters, state.DefaultColumnSorting, state.SavedFilters, state.WithQueryParameters), singleton((dispatch_1) => {
                dispatch_1(new TableMsg$1(17, []));
            })];
        }
        case 9:
            return [new State$1(state.TableKey, state.SaveTableConfiguration, state.GlobalSearchPattern, state.SelectedRows, state.CSVDownloadRunning, state.IsFullscreen, state.ColumnFilters, state.ColumnSorting, state.VisibleColumns, msg.fields[0], state.TableConfiguration, state.ColumnDefinitions, state.ColumnDefinitionMap, state.DefaultColumnFilters, state.DefaultColumnSorting, state.SavedFilters, state.WithQueryParameters), singleton((dispatch_2) => {
                dispatch_2(new TableMsg$1(17, []));
            })];
        case 10:
            return [new State$1(state.TableKey, state.SaveTableConfiguration, "", state.SelectedRows, state.CSVDownloadRunning, state.IsFullscreen, defaultArg(map(toArray, state.DefaultColumnFilters), []), state.ColumnSorting, state.VisibleColumns, state.ColumnOrder, state.TableConfiguration, state.ColumnDefinitions, state.ColumnDefinitionMap, state.DefaultColumnFilters, state.DefaultColumnSorting, state.SavedFilters, state.WithQueryParameters), state.WithQueryParameters ? Cmd_ofEffect((_arg_4) => {
                removeTableFilterQueryParams(state.ColumnDefinitionMap);
            }) : Cmd_none()];
        case 11: {
            const savedFilter = msg.fields[0];
            return [new State$1(state.TableKey, state.SaveTableConfiguration, state.GlobalSearchPattern, state.SelectedRows, state.CSVDownloadRunning, state.IsFullscreen, state.ColumnFilters, state.ColumnSorting, state.VisibleColumns, state.ColumnOrder, state.TableConfiguration, state.ColumnDefinitions, state.ColumnDefinitionMap, state.DefaultColumnFilters, state.DefaultColumnSorting, exists((existingFilter) => (existingFilter.Name === savedFilter.Name), state.SavedFilters) ? map_2((existingFilter_1) => {
                if (existingFilter_1.Name === savedFilter.Name) {
                    return savedFilter;
                }
                else {
                    return existingFilter_1;
                }
            }, state.SavedFilters) : append_1(state.SavedFilters, singleton(savedFilter)), state.WithQueryParameters), singleton((dispatch_3) => {
                dispatch_3(new TableMsg$1(17, []));
            })];
        }
        case 12:
            return [new State$1(state.TableKey, state.SaveTableConfiguration, state.GlobalSearchPattern, state.SelectedRows, state.CSVDownloadRunning, state.IsFullscreen, state.ColumnFilters, state.ColumnSorting, state.VisibleColumns, state.ColumnOrder, state.TableConfiguration, state.ColumnDefinitions, state.ColumnDefinitionMap, state.DefaultColumnFilters, state.DefaultColumnSorting, map_2((savedFilter_1) => {
                if (savedFilter_1.Name === msg.fields[0]) {
                    return new SavedTableFilter(msg.fields[1], savedFilter_1.ColumnFilters);
                }
                else {
                    return savedFilter_1;
                }
            }, state.SavedFilters), state.WithQueryParameters), singleton((dispatch_4) => {
                dispatch_4(new TableMsg$1(17, []));
            })];
        case 13:
            return [new State$1(state.TableKey, state.SaveTableConfiguration, state.GlobalSearchPattern, state.SelectedRows, state.CSVDownloadRunning, state.IsFullscreen, state.ColumnFilters, state.ColumnSorting, state.VisibleColumns, state.ColumnOrder, state.TableConfiguration, state.ColumnDefinitions, state.ColumnDefinitionMap, state.DefaultColumnFilters, state.DefaultColumnSorting, filter_1((savedFilter_2) => (savedFilter_2.Name !== msg.fields[0]), state.SavedFilters), state.WithQueryParameters), singleton((dispatch_5) => {
                dispatch_5(new TableMsg$1(17, []));
            })];
        case 14:
            return [new State$1(state.TableKey, state.SaveTableConfiguration, state.GlobalSearchPattern, state.SelectedRows, state.CSVDownloadRunning, state.IsFullscreen, state.ColumnFilters, [{
                desc: state.DefaultColumnSorting[1] === "desc",
                id: state.DefaultColumnSorting[0],
            }], map_3((_arg_5) => _arg_5.Id, state.ColumnDefinitions), map_3((_arg_6) => _arg_6.Id, state.ColumnDefinitions), state.TableConfiguration, state.ColumnDefinitions, state.ColumnDefinitionMap, state.DefaultColumnFilters, state.DefaultColumnSorting, state.SavedFilters, state.WithQueryParameters), singleton((dispatch_6) => {
                dispatch_6(new TableMsg$1(17, []));
            })];
        case 15:
            return [state, Cmd_none()];
        case 16: {
            const tableConfiguration_1 = defaultArg(msg.fields[0], new TableConfiguration_1(ofArray(map_3((_arg_7) => _arg_7.Id, state.ColumnDefinitions)), ofArray(map_3((_arg_8) => _arg_8.Id, state.ColumnDefinitions)), undefined, empty()));
            const migrateColumnId_1 = (columnId_6) => migrateColumnId(state.ColumnDefinitionMap, columnId_6);
            return [(VisibleColumns_3 = ((array_25 = Array_distinct(map_3(migrateColumnId_1, toArray(tableConfiguration_1.VisibleColumns)), {
                Equals: (x_5, y_5) => (x_5 === y_5),
                GetHashCode: (x_5) => (stringHash(x_5) | 0),
            }), array_25.filter((key) => FSharpMap__ContainsKey(state.ColumnDefinitionMap, key)))), (ColumnOrder_2 = Array_distinct(map_3(migrateColumnId_1, toArray(tableConfiguration_1.ColumnOrder)), {
                Equals: (x_6, y_6) => (x_6 === y_6),
                GetHashCode: (x_6) => (stringHash(x_6) | 0),
            }), new State$1(state.TableKey, state.SaveTableConfiguration, state.GlobalSearchPattern, state.SelectedRows, state.CSVDownloadRunning, state.IsFullscreen, state.ColumnFilters, (matchValue = tableConfiguration_1.RowSort, (matchValue == null) ? state.ColumnSorting : ((rowSort = matchValue, [(id_1 = migrateColumnId_1(rowSort.ColumnId), {
                desc: equals(rowSort.RowSortDirection, new RowSortDirection(1, [])),
                id: id_1,
            })]))), VisibleColumns_3, ColumnOrder_2, new RequestedValue$1(1, [tableConfiguration_1]), state.ColumnDefinitions, state.ColumnDefinitionMap, state.DefaultColumnFilters, state.DefaultColumnSorting, map_2((savedFilter_3) => (new SavedTableFilter(savedFilter_3.Name, map_2((columnFilter) => (new SavedColumnFilter(migrateColumnId_1(columnFilter.ColumnId), columnFilter.Values)), savedFilter_3.ColumnFilters))), tableConfiguration_1.SavedFilters), state.WithQueryParameters))), Cmd_none()];
        }
        case 17:
            if (state.SaveTableConfiguration) {
                return [state, (tableConfiguration_2 = ((VisibleColumns_4 = ofArray(state.VisibleColumns), new TableConfiguration_1(ofArray(state.ColumnOrder), VisibleColumns_4, map((sort) => (new RowSort(sort.id, sort.desc ? (new RowSortDirection(1, [])) : (new RowSortDirection(0, [])))), tryHead(state.ColumnSorting)), state.SavedFilters))), (body = toString(0, Auto_generateBoxedEncoder_437914C6(TableConfiguration_$reflection(), undefined, undefined, undefined)(tableConfiguration_2)), Cmd_OfPromise_either((tupledArg_3) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let url_2;
                    return ((url_2 = addPrefix(tupledArg_3[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg_3[1]])]), "application/json", (response) => {
                        const pr = response.arrayBuffer();
                        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                    }, refreshOn)))(true);
                })), [concat("/api/users/configuration/table/", ...state.TableKey), body], (Item) => (new TableMsg$1(18, [Item])), (Item_1) => (new TableMsg$1(19, [Item_1])))))];
            }
            else {
                return [state, Cmd_none()];
            }
        case 18:
            return [state, Cmd_none()];
        case 19:
            return [state, Cmd_none()];
        default: {
            const columnDefinitions = msg.fields[0];
            const newColumnDefinitionIds = map_3((_arg_1) => _arg_1.Id, columnDefinitions.filter((columnDefinition) => !contains_1(columnDefinition.Id, map_3((_arg) => _arg.Id, state.ColumnDefinitions), {
                Equals: (x, y) => (x === y),
                GetHashCode: (x) => (stringHash(x) | 0),
            })));
            return [new State$1(state.TableKey, state.SaveTableConfiguration, state.GlobalSearchPattern, state.SelectedRows, state.CSVDownloadRunning, state.IsFullscreen, state.ColumnFilters, state.ColumnSorting, (array_7 = map_3((_arg_2) => _arg_2.Id, columnDefinitions), array_7.filter((columnId) => {
                if (contains_1(columnId, newColumnDefinitionIds, {
                    Equals: (x_1, y_1) => (x_1 === y_1),
                    GetHashCode: (x_1) => (stringHash(x_1) | 0),
                })) {
                    return true;
                }
                else {
                    return contains_1(columnId, state.VisibleColumns, {
                        Equals: (x_2, y_2) => (x_2 === y_2),
                        GetHashCode: (x_2) => (stringHash(x_2) | 0),
                    });
                }
            })), append_2(state.ColumnOrder.filter((columnId_1) => columnDefinitions.some((cd) => (cd.Id === columnId_1))), newColumnDefinitionIds), state.TableConfiguration, columnDefinitions, ofArray_1(map_3((columnDefinition_1) => [columnDefinition_1.Id, columnDefinition_1], columnDefinitions), {
                Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
            }), state.DefaultColumnFilters, state.DefaultColumnSorting, state.SavedFilters, state.WithQueryParameters), Cmd_none()];
        }
    }
}

export function getColumnVisibilityObject(columnDefinitions, visibleColumns) {
    return createObj(map_3((columnDefinition_1) => [columnDefinition_1.Id, false], columnDefinitions.filter((columnDefinition) => !contains_1(columnDefinition.Id, visibleColumns, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    }))));
}

